import { proxy } from 'valtio';

export enum InlineRovoPromptTriggerSource {
  TableEntry = 'table-entry',
  TableField = 'table-field',
  BoardEntry = 'board-entry',
  GalleryEntry = 'gallery-entry',
  ViewMenu = 'view-menu',
  RichTextToolbar = 'rich-text-toolbar',
}

type InlineRovoPromptState = {
  isOpen: boolean;
  openedFrom: InlineRovoPromptTriggerSource;
};

export const inlineRovoPromptState = proxy<InlineRovoPromptState>({
  isOpen: false,
  openedFrom: InlineRovoPromptTriggerSource.TableEntry,
});

export const openInlineRovoPrompt = (source: InlineRovoPromptTriggerSource) => {
  inlineRovoPromptState.isOpen = true;
  inlineRovoPromptState.openedFrom = source;
};

export const closeInlineRovoPrompt = () => {
  inlineRovoPromptState.isOpen = false;
};
